import { Component, ElementRef, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { CacheFlowService } from '../../../../../services/cache-flow.service';
import { CountableTimeZonePipe } from 'countable@helpers';

@Component({
  selector: 'app-cash-flow-work-sheet',
  templateUrl: './cash-flow-work-sheet.component.html',
  styleUrls: ['./cash-flow-work-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CashFlowWorkSheetComponent implements OnInit {
  //@ViewChild('confirmDialog') confirmDialog: TemplateRef<any>;
  @ViewChild('confirmDelete') confirmDelete: TemplateRef<any>;
  //properties declarations
  engagementId              : number;
  selectedEngagementObj     : any;
  yearEnd                   : number;
  acctYear                  : number;
  cashFlowData              : any;
  cashFlowLeftData          : any     = [];
  userDetails               : any;
  userLoginId               : number;
  cashflowtypeid            : number;
  tbcashflowid              : number;
  trailbalanceid            : number;
  previewCashFlowData       : any     = [];
  isActiveNewRow            : boolean = false;
  leftSideCashFlowTypeId    : number;
  isEditLeftSideRow         : boolean = false;
  addCashFlowId             : number  = 0;
  confirmMessage            : string;
  cashFlowMiddleData        : any     = [];
  currentYear               : number;
  previousYear              : number;
  isFocusNewMiddleRow       : boolean = false;
  isFocusOldMiddleRow       : boolean = false;
  cashFlowLineItemId        : number;
  addC                      : number;
  middleLeadsheetId         : number;
  cfoAmount                 : string;
  cashLineItemname          : string;
  netAmountName             : string;
  netAmount                 : string;
  mainYears                 : any     = [];
  yearId                    : number  = 0;
  isDataLoaded              : boolean = false;
  //preview save form
  previewForm: UntypedFormGroup;

  constructor(public dialog: MatDialog, private toaster: ToastrService, private fb: UntypedFormBuilder,private countableTimeZonePipe: CountableTimeZonePipe,
              private cacheFlowService: CacheFlowService) { }

  ngOnInit() {
      this.selectedEngagementObj  = JSON.parse((localStorage.getItem('selectedEngagementObj')));
      let year                    = this.countableTimeZonePipe.transform(this.selectedEngagementObj.yearEnd, 'yyyy');
      this.yearEnd                = +year;
      this.engagementId           = this.selectedEngagementObj.engagementsid;
      this.acctYear               = +year;
      //get the user details
      this.userDetails            = JSON.parse(localStorage.getItem('userDetails'));
      this.userLoginId            = this.userDetails.useracctid;
      //Default methods calling
      //this.getPreviewCashFlow();
      this.getCommonData();
  }
  //confirm dialog for delete and update
  confirm(type: string, addCashFlowId?: number, lineItemName?: string) {
    if(type === "UPDATE"){
      this.confirmMessage = "Save your changes before leaving?";
    }
    else if(type === "DELETE"){
      this.confirmMessage = "Are you sure you want to delete?";
    }
    this.addCashFlowId    = addCashFlowId;
    this.cashLineItemname = lineItemName;
    const dialogRef = this.dialog.open(this.confirmDelete, {});
    dialogRef.afterClosed().subscribe(result => {});
  }

  //Refresh Grid
  refresh(type: string) {
    if(type === 'RIGHT'){
      this.getPreviewCashFlow();
    }
    else{
      this.getCommonData();
    }
  }

  //get the preview cash flow details
  getPreviewCashFlow(): void{
    this.cacheFlowService.getCacheFlow(this.engagementId, this.yearEnd).subscribe({
      next: res => {
        const responseData = JSON.parse(res);
        if (responseData && responseData.length > 0) {
          this.cashFlowData = responseData;

        }
        else {
          this.cashFlowData = [];
        }
      }
    });
  }

  //not using
  prepareCashFlowData(event, trailbalanceId: number, tbcashflowId: number){

    let cashFlowTypeId = event.source.value;
    const data = { "cashflowtypeid":  cashFlowTypeId, "trailBalanceid": trailbalanceId, "loginid": this.userLoginId, "tbcashflowid": tbcashflowId}
    if(this.previewCashFlowData.length === 0){
      this.previewCashFlowData.push(data);
    }
    else{
      this.previewCashFlowData.filter((e) => {
        if(e.trailBalanceid == trailbalanceId && e.cashflowtypeid !== cashFlowTypeId)
        {
          this.previewCashFlowData.push(data);
        }
      });
    }

  }

  //save the right side preview data
  savePreviewCashFlow(event, trailbalanceId: number, tbcashflowId: number) {
    let cashFlowTypeId = event.source.value;
    //preparing input data
    const inputString = {
      "cashflow": [{
        "cashflowtypeid"  : cashFlowTypeId,
        "trailBalanceid"  : trailbalanceId,
        "isdelete"        : 0,
        "tbcashflowid"    : tbcashflowId
      }]
    }
    const inputObject = JSON.stringify(inputString);
    this.cacheFlowService.savePreviewCFType(inputObject).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.getPreviewCashFlow();
          this.toaster.success('Preview saved successfully');
        }
      }, error: e => {
        this.toaster.error('Something Went Wrong!');
        this.getPreviewCashFlow();
      }
    });
  }

  getYearWiseData(year: number, id: number){
    this.acctYear             = year;
    this.yearId               = id;
    this.getCommonData();
  }

  //Active for add | edit option
  activeRow(typeId: number, type: string, addCashFlowId?: number, lineItemName?: string): void {
    this.leftSideCashFlowTypeId = typeId;
    if(addCashFlowId !== undefined){
      this.addCashFlowId = addCashFlowId;
    }
    if(lineItemName !== undefined){
      this.cashLineItemname = lineItemName;
    }
    if(type === 'ADD'){
      this.isActiveNewRow = true;
      this.isEditLeftSideRow  = false;
      this.cashLineItemname   = "";
    }
    else{
      this.isActiveNewRow     = false;
      this.isEditLeftSideRow  = true;
    }
    this.isFocusNewMiddleRow  = false;
    this.isFocusOldMiddleRow  = false;
  }

  closeActiveRow(typeId: number, type: string): void {
    this.leftSideCashFlowTypeId = typeId;
    type === 'ADD' ? this.isActiveNewRow = false : this.isEditLeftSideRow = false;
  }

  //common stored procedure for add, update and delete
  updateActiveRow(type: string, addCashFlowId?: number): void {
    let isDelete = type === 'DELETE' ? 1 : 0;
    if(addCashFlowId !== undefined){
      this.addCashFlowId = addCashFlowId;
    }
    if(!this.cashLineItemname){
      this.toaster.error("Please enter the required field!");
      return;
    }
    //preparing input data
    const inputString = {
      "addcashflow": [{
        "cashflowtypeid"  : this.leftSideCashFlowTypeId,
        "engagementsid"   : this.engagementId,
        "leadsheetid"     : 0,
        "lineitemname"    : this.cashLineItemname,
        "amount"          : 0,
        "acctyear"        : this.acctYear,
        "isdelete"        : isDelete,
        "addcashflowid"   : this.addCashFlowId
      }]
    }
    const inputObject = JSON.stringify(inputString);
    this.cacheFlowService.saveAddCashFlow(inputObject).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.getCommonData(true, type);
        }
      }, error: e => {
        this.toaster.error('failed');
      }
    });
  }

  trackByFn(index, item) {

    return index; // or item.id
  }
  activeMiddleRow(type: string, id: number, leadsheetId: number, amount?: string){
    if(type === "OLD"){
      this.cashFlowLineItemId   = id;
      this.isFocusNewMiddleRow  = false;
      this.isFocusOldMiddleRow  = true;
      this.cfoAmount = amount == '0' || amount == '0.00' || amount == null ? null : amount.replace(/\,|\)/g, '').replace(/\(/g, '-');
    }
    else{
      this.addCashFlowId        = id;
      this.isFocusNewMiddleRow  = true;
      this.isFocusOldMiddleRow  = false;
      this.cfoAmount = amount == '0' || amount == '0.00' || amount == null ? null : amount.replace(/\,|\)/g, '').replace(/\(/g, '-');
    }
    this.middleLeadsheetId = leadsheetId;
    this.isActiveNewRow = false;
    this.isEditLeftSideRow  = false;

  }
  close(type: string, id: number){
    if(type === "OLD"){
      this.cashFlowLineItemId   = id;
      this.isFocusOldMiddleRow  = false;
    }
    else{
      this.addCashFlowId        = id;
      this.isFocusNewMiddleRow  = false;
    }
    this.cfoAmount = null;
  }

  saveMiddleAmount(type: string, commonId: number, uniqueId: number, leadSheetId: number){
    let cashFlowLineItemId  : number = 0,
    addCashFlowId           : number = 0,
    addcashflowamountid     : number = 0,
    tbcashflowamountchangeid: number = 0,
    acctYear                : any    = 0,
    engagementId            : any    = 0,
    amount                  : string;

    if(type === "OLD"){
      cashFlowLineItemId        = commonId;
      engagementId              = this.engagementId;
      acctYear                  = this.acctYear;
      tbcashflowamountchangeid  = uniqueId;//0 | id
    }
    else{
      addCashFlowId       = commonId;
      engagementId        = 0;
      acctYear            = 0;
      addcashflowamountid = uniqueId;//0 | id
    }
    if(this.cfoAmount){
      amount = this.cfoAmount
      .replace(/[^0-9-]/g, '')       // remove chars except number, hyphen, point.
      //.replace(/(\..*)\./g, '$1')     // remove multiple points.
      .replace(/(?!^)-/g, '')         // remove middle hyphen.
      .replace(/^0+(\d)/gm, '$1');
    }
    if(!this.cfoAmount){
      this.toaster.error("Specify the required amount");
    }
    else if(amount === "-" || amount === null || amount === "-0"){
      this.cfoAmount = "";
      this.toaster.error("Specify the valid amount");
    }
    else{
      const inputString = {
        "cashflow": [
          {
            "addcashflowid"           : addCashFlowId,
            "leadsheetid"             : leadSheetId,
            "amount"                  : amount,
            "addcashflowamountid"     : addcashflowamountid,
            "cashflowlineitemid"      : cashFlowLineItemId,
            "tbcashflowamountchangeid": tbcashflowamountchangeid,
            "engagementsid"           : engagementId,
            "acctyear"                : acctYear,
            "isdelete"                : 0,
          }
        ]
      }
      const inputObject = JSON.stringify(inputString);
      this.cacheFlowService.saveAddCFAmount(inputObject).subscribe({
        next: res => {
          if (res.status === 200 && res?.data) {
            this.getCommonData(true, 'EDIT');
          }
        }, error: e => {
          this.toaster.error('failed');
        }
      });
    }
  }

  getCommonData(isDisplay?: boolean, type?: string){
    this.isDataLoaded = false;
    let response1, response2, response3, res1, res2, res3;
    response1 = this.cacheFlowService.getCFMiddle(this.engagementId, this.yearEnd);
    response2 = this.cacheFlowService.getCFLeft(this.engagementId, this.yearEnd);
    response3 = this.cacheFlowService.getCacheFlow(this.engagementId, this.yearEnd);
    forkJoin([response1, response2, response3]).subscribe((results: any[]) => {
      res1 = JSON.parse(results[0] as string); // results[0] is our middle section
      res2 = JSON.parse(results[1] as string); // results[1] is our left section
      res3 = JSON.parse(results[2] as string); // results[2] is our right section
      if ((res1 && res1.length > 0) && (res2 && res2.length > 0) && (res3 && res3.length > 0)) {
        this.cashFlowMiddleData = res1;
        this.cashFlowLeftData   = res2;
        this.cashFlowData       = res3;
        this.currentYear        = this.cashFlowMiddleData[0].years[0].curyear;
        this.previousYear       = this.cashFlowMiddleData[0].years[0].preyear;
        this.netAmountName      = this.cashFlowLeftData[0].leftbottomtotal.name;
        this.netAmount          = this.cashFlowLeftData[0].leftbottomtotal.amount;
        this.mainYears          = this.cashFlowLeftData[0].leftsideyear;

      }
      else {
        this.cashFlowMiddleData = [];
        this.cashFlowLeftData   = [];
      }
      this.isDataLoaded = true;
      this.isActiveNewRow       = false;
      this.isEditLeftSideRow    = false;
      this.isFocusNewMiddleRow  = false;
      this.isFocusOldMiddleRow  = false;
      if(isDisplay === true && type === "EDIT"){
        this.toaster.success("Updated successfully");
      }
      else if(isDisplay === true && type === "ADD"){
        this.toaster.success("Saved successfully");
      }
      else if(isDisplay === true && type === "DELETE"){
        this.toaster.success("Deleted successfully");
      }

    }, error => {
      console.log(error);
    });
  }
  onlyNumberKey(event) {

    return (event.charCode == 8 || event.charCode == 0) ? null : (event.charCode >= 48 && event.charCode <= 57) || (event.charCode ==45 );
  }
}
